import React, { useCallback, useState } from "react";
import { Button, classnames, Icon, ModalDialog, StringField, Success } from "@culturehq/components";

import { errorService, Trans } from "app/utils";
import ChqModalDialog from "components/common/ChqModalDialog";

const CopyLink = ({
  link,
  noIcon = undefined,
  onClose: onCloseMenu = undefined,
  onOpenChildren = undefined,
  orgName,
  shareButton = false,
  hash = undefined,
  label = "Copy External Link",
  copyText = "Below is an external link that you can share with anybody.",
  ShareButtonRenderer
}) => {
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);

  const onCopy = useCallback(
    () => {
      if (open) {
        document.querySelector("#url").select();
        document.execCommand("copy");
        setCopied(true);
      } else {
        navigator.clipboard.writeText(link)
          .then(() => setCopied(true))
          .catch(err => errorService.error(`Failed to copy: ${err}`));
      }
    },
    [link, open, setCopied]
  );

  const onOpen = useCallback(() => {
    setOpen(true);
    setTimeout(onCopy, 0);
    if (onOpenChildren) onOpenChildren();
  }, [onCopy, onOpenChildren, setOpen]);

  const onClose = useCallback(
    () => {
      setCopied(false);
      setOpen(false);
      if (onCloseMenu) onCloseMenu();
    },
    [onCloseMenu, setCopied, setOpen]
  );

  const ShareButton = ShareButtonRenderer ? <ShareButtonRenderer onClick={onOpen} /> : (
    <Button className="Gray-Button" onClick={onOpen}>
      {!noIcon && <Icon icon="share" />}
      <Trans>Share Page</Trans>
    </Button>
  );

  return (
    <>
      {shareButton ? (
        ShareButton
      ) : (
        <Button className="Copy-Button" onClick={onOpen}>
          {!noIcon && <Icon icon="link-wider" />}
          <Trans>{label}</Trans>
        </Button>
      )}
      {open && (
        <ChqModalDialog onClose={onClose} className={classnames("link-share", orgName)}>
          <ModalDialog.Heading onClose={onClose}>
            <Trans>{label}</Trans>
          </ModalDialog.Heading>
          <ModalDialog.Body>
            <p><Trans>{copyText}</Trans></p>
            <StringField
              readOnly
              name="url"
              value={link}
            />
            {copied && (
              <Success>
                {hash ? (
                  <Trans>Hash copied to the clipboard.</Trans>
                ) : (
                  <Trans>Direct link copied to the clipboard.</Trans>
                )}
              </Success>
            )}
          </ModalDialog.Body>
          <ModalDialog.Footer>
            <div>
              <Button inverted onClick={onClose}>
                <Trans>Close</Trans>
              </Button>
            </div>
            <div>
              <Button primary onClick={onCopy}>
                <Trans>Copy</Trans>
              </Button>
            </div>
          </ModalDialog.Footer>
        </ChqModalDialog>
      )}
    </>
  );
};

export default CopyLink;
